import React from "react";
import { Card, Col, Row, Divider, Tooltip as AntToolTip } from "antd";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  BarChart,
  Bar,
} from "recharts";

const currentOccupancy = (
  <p style={{ color: "#000" }}>
    Occupancy & vacancy metrics include all rentable units which do or do not
    have a current tenant.
  </p>
);
const projectOccupancy = (
  <p style={{ color: "#000" }}>
    This chart displays your projected occupancy rate for the next 8 weeks,
    based on the move out and move in date of each tenant. It does not include
    hidden tenants.
  </p>
);
const OccupancyInformation = () => {
  const ProjectedOccupancyRate = [
    { name: "Page A", uv: 4000 },
    { name: "Page B", uv: 3000 },
    { name: "Page C", uv: 2000 },
    { name: "Page D", uv: 1000 },
    { name: "Page E", uv: 1890 },
    { name: "Page F", uv: 2390 },
    { name: "Page G", uv: 3490 },
  ];

  const ProjectedVacancyExposure = [
    {
      name: "Mar 2023",
      uv: 4000,
      pv: 2400,
      amt: 2400,
    },
    {
      name: "Apr 2023",
      uv: 3000,
      pv: 1398,
      amt: 2210,
    },
    {
      name: "May 2023",
      uv: 2000,
      pv: 9800,
      amt: 2290,
    },
    {
      name: "Jun 2023",
      uv: 2780,
      pv: 3908,
      amt: 2000,
    },
    {
      name: "Jul 2023",
      uv: 1890,
      pv: 4800,
      amt: 2181,
    },
    {
      name: "Aug 2023",
      uv: 2390,
      pv: 3800,
      amt: 2500,
    },
    {
      name: "Sep 2023",
      uv: 3490,
      pv: 4300,
      amt: 2100,
    },
    {
      name: "Oct 2023",
      uv: 3490,
      pv: 4300,
      amt: 2100,
    },
    {
      name: "Nov 2023",
      uv: 3490,
      pv: 4300,
      amt: 2100,
    },
    {
      name: "Dec 2023",
      uv: 3490,
      pv: 4300,
      amt: 2100,
    },
    {
      name: "Jan 2024",
      uv: 3490,
      pv: 4300,
      amt: 2100,
    },
    {
      name: "Feb 2024",
      uv: 3490,
      pv: 4300,
      amt: 2100,
    },
  ];

  return (
    <div className="OccupancyInformation">
      <p>
        Current Occupancy{" "}
        <AntToolTip
          placement="bottom"
          title={currentOccupancy}
          trigger={["click"]}
          color={["#ffffff"]}
        >
          <i className="fa-solid fa-circle-question"></i>
        </AntToolTip>
      </p>
      <br />
      <div className="pricingMatricsCards">
        <Row justify="space-between">
          <Col span={11}>
            <Card>
              <h1>-%</h1>
              <p>Occupancy</p>
            </Card>
          </Col>
          <Col span={11}>
            <Card>
              <h1>-</h1>
              <a href="/">Units Vacant</a>
            </Card>
          </Col>
        </Row>
      </div>
      <Divider />
      <p>
        Projected Occupancy Rate{" "}
        <AntToolTip
          placement="bottom"
          title={projectOccupancy}
          trigger={["click"]}
          color={["#ffffff"]}
        >
          <i className="fa-solid fa-circle-question"></i>
        </AntToolTip>
      </p>
      <br />
      <ResponsiveContainer width="100%" height={200}>
        <LineChart
          width={500}
          height={200}
          data={[]}
          margin={{
            top: 10,
            right: 30,
            left: 0,
            bottom: 0,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Line
            connectNulls
            type="monotone"
            dataKey="uv"
            stroke="rgb(44, 165, 220)"
            fill="rgb(44, 165, 220)"
          />
        </LineChart>
      </ResponsiveContainer>
      <Divider />
      <p>
        Projected Vacancy Exposure{" "}
        <AntToolTip
          placement="bottom"
          title={currentOccupancy}
          trigger={["click"]}
          color={["#ffffff"]}
        >
          <i className="fa-solid fa-circle-question"></i>
        </AntToolTip>
      </p>
      <br />
      <ResponsiveContainer width="100%" height={300}>
        <BarChart width={500} height={300} data={[]}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Bar dataKey="uv" fill="rgb(44, 165, 220)" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default OccupancyInformation;
